import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import { Button, Space } from 'antd'
import type { ServiceOrder } from '@super-mega/server/contracts/order'
import { OrderBillsDrawer } from '@/features/bill/index.ts'
import { ServiceLifecycleActions } from './service-lifecycle-actions.tsx'

export function ServiceOrderActions({
  order,
  canManage,
  canReadBills,
  disabled = false
}: {
  order: ServiceOrder
  canManage: boolean
  canReadBills: boolean
  disabled?: boolean
}) {
  const [viewingBills, setViewingBills] = useState(false)
  return (
    <>
      {viewingBills && canReadBills && (
        <OrderBillsDrawer
          order={{ type: 'service', id: order.id, orderNo: order.orderNo }}
          onClose={() => setViewingBills(false)}
        />
      )}
      <Space wrap>
        <Link to="/orders/service/contract/$orderId" params={{ orderId: String(order.id) }} target="_blank">
          <Button>打印合同</Button>
        </Link>
        {canReadBills && (
          <Button disabled={disabled} onClick={() => setViewingBills(true)}>
            查看账单
          </Button>
        )}
        {canManage && <ServiceLifecycleActions order={order} disabled={disabled} />}
      </Space>
    </>
  )
}
